import { render, staticRenderFns } from "./proofUploading.vue?vue&type=template&id=ea72ea5e&scoped=true&"
import script from "./proofUploading.vue?vue&type=script&lang=js&"
export * from "./proofUploading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea72ea5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea72ea5e')) {
      api.createRecord('ea72ea5e', component.options)
    } else {
      api.reload('ea72ea5e', component.options)
    }
    module.hot.accept("./proofUploading.vue?vue&type=template&id=ea72ea5e&scoped=true&", function () {
      api.rerender('ea72ea5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/order/refund/components/proofUploading.vue"
export default component.exports